import React from 'react';
import { FlameIcon, LightbulbIcon, MessageSquareTextIcon, TimerIcon, UsersIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { bonuses, BonusIcon } from '../data/bonuses';
import { optimizedImage } from '../utils/image';
const icons: Record<BonusIcon, typeof TimerIcon> = {
  timer: TimerIcon,
  message: MessageSquareTextIcon,
  users: UsersIcon,
  flame: FlameIcon,
  lightbulb: LightbulbIcon
};
export function BonusesSection() {
  return <section id="bonuses" className="defer-paint w-full scroll-mt-6 bg-navy py-14 sm:py-20" aria-labelledby="bonuses-heading" data-id="element-13" data-mp="zuhj3eescjjk">
      <div className="mx-auto max-w-5xl px-6" data-id="element-14" data-mp="1ejnh4z1w03pv">
        <SectionHeading eyebrow="Included free" title={<span id="bonuses-heading" data-id="element-16" data-mp="19jrg98ohksej">+ 5 practical coaching bonuses</span>} lead="Practical tools that solve real problems before and during training." data-id="element-15" data-mp="1elgpcis5evzz" />

        <ul className="mt-12 grid gap-4 md:grid-cols-2 md:gap-5" data-id="element-17" data-mp="1nhzhhssk2fvi">
          {bonuses.map((bonus, index) => {
          const Icon = icons[bonus.icon];
          const isLastOdd = index === bonuses.length - 1 && bonuses.length % 2 === 1;
          return <li key={bonus.number} className={`flex items-center gap-5 rounded-3xl border border-line bg-ink p-4 sm:p-5 ${isLastOdd ? 'md:col-span-2 md:mx-auto md:w-[calc(50%-0.625rem)]' : ''}`} data-id="element-18" data-mp="3trduby1zzj5q" data-mpi={index}>
                {bonus.image ? <img src={optimizedImage(bonus.image, 240)} alt={`${bonus.title} cover`} className="h-24 w-24 shrink-0 rounded-2xl object-cover sm:h-28 sm:w-28" width={240} height={240} loading="lazy" decoding="async" data-id="element-19" data-mp="7lqkoop4p195" /> : <span className="flex h-24 w-24 shrink-0 items-center justify-center rounded-2xl sm:h-28 sm:w-28" style={{
              backgroundColor: `${bonus.color}26`,
              boxShadow: `inset 0 0 0 1px ${bonus.color}66`
            }} aria-hidden="true" data-id="element-20" data-mp="gk2m7lrj9jgd">
                    <Icon className="h-10 w-10" style={{
                color: bonus.color
              }} strokeWidth={1.6} data-id="element-21" data-mp="vatc2o9ke8gu" />
                  </span>}

                <div className="min-w-0 flex-1" data-id="element-22" data-mp="109mjbyy9d38k">
                  <div className="flex items-center gap-2" data-id="element-23" data-mp="akpcw3xgwdau">
                    <span className="font-display text-sm font-semibold uppercase tracking-[0.18em] text-muted" data-id="element-24" data-mp="aiw86u6f035h">
                      Bonus {bonus.number}
                    </span>
                    <span className="rounded-full bg-cta px-2.5 py-0.5 font-display text-xs font-bold uppercase tracking-[0.12em] text-on-accent" data-id="element-25" data-mp="kcd3k2m79qb9">
                      Free
                    </span>
                  </div>
                  <h3 className="mt-1.5 font-display text-2xl font-extrabold uppercase leading-[1.05] text-fg" data-id="element-26" data-mp="ocniw5vvtt2s">
                    {bonus.title}
                  </h3>
                  <p className="mt-1.5 text-[0.92rem] leading-relaxed text-muted" data-id="element-27" data-mp="1394tguw8z3oa">{bonus.tagline}</p>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}